<template>
    <div>
        <div class="row">
            <div
                v-if="loading"
                class="col-12 mt-5"
                v-loading="true"></div>
            <div v-else class="col-md-12">
                <card>
                    <template slot="header">
                        <div class="d-flex justify-content-between align-items-center">
                            <span>Users</span>
                            <router-link :to="{ name: 'users-invite' }">
                                <n-button
                                    type="default"
                                    size="mini">
                                        Invite
                                </n-button>
                            </router-link>
                        </div>
                    </template>
                    <el-table :data="$store.state.users" stripe border class="header-background">
                        <el-table-column label="E-Mail ID" prop="email"/>
                        <el-table-column label="Name" prop="name"/>
                        <el-table-column label="Actions">
                            <template slot-scope="props">
                                <router-link
                                    v-if="user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].editUsers)"
                                    :to="{ name: 'users-edit', params: { userId: props.row._id } }">
                                        <el-tooltip content="Edit" placement="top">
                                            <el-button class="btn" title="Edit">
                                                <fa :icon="['fas', 'pen']"/>
                                            </el-button>
                                        </el-tooltip>
                                </router-link>
                                <el-tooltip content="Delete" placement="top">
                                    <el-button
                                        @click="remove(props.row._id)"
                                        class="btn btn-danger ml-1"
                                        title="Delete" :disabled="!user.admin">
                                            <fa :icon="['fas', 'trash']"/>
                                    </el-button>
                                </el-tooltip>
                                <el-switch
                                    v-model="props.row.status"
                                    active-text="Enable"
                                    inactive-text="Disable"
                                    :disabled="!user.admin"
                                    @change="statusChsage(props.row._id)"
                                    />
                            </template>
                        </el-table-column>
                    </el-table>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import swal from 'sweetalert2'
import { mapState } from 'vuex'
import http from '../../http.js'

export default {
    data () {
        return {
            loading: false
        }
    },
    computed: {
        ...mapState([
            'user',
            'event'
        ])
    },
    mounted () {
        this.getUsers()
    },
    methods: {
        getUsers: async function () {
            this.loading = true
            try {
                await this.$store.dispatch('getAll', {
                    path: 'users',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
            } catch (e) {
                console.log('erorr getting users')
            }
            this.loading = false
        },
        remove: async function (id) {
            try {
                let { value: confirmed } = await swal({
                    title: `Are you sure you want to delete this user?`,
                    buttonsStyling: false,
                    showCancelButton: true,
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    confirmButtonClass: 'btn btn-success btn-fill',
                    cancelButtonClass: 'btn btn-default btn-fill'
                })

                if (confirmed) {
                    this.$store.commit('SET', ['users', this.$store.state.users.filter(user => user._id !== id)])
                    this.$store.dispatch('remove', { path: 'users', id })
                }
            } catch (e) {
                console.log(e)
                console.log('error deleting user')
            }
        },
        statusChsage: async function (id) {
            try {
                const usr = await http.put(`/api/user-status/${id}`)
                //console.log('@@usr', usr)
                // let { value: confirmed } = await swal({
                //     title: `Are you sure you want to delete this user?`,
                //     buttonsStyling: false,
                //     showCancelButton: true,
                //     confirmButtonText: 'OK',
                //     cancelButtonText: 'Cancel',
                //     confirmButtonClass: 'btn btn-success btn-fill',
                //     cancelButtonClass: 'btn btn-default btn-fill'
                // })

                // if (confirmed) {
                //     this.$store.commit('SET', ['users', this.$store.state.users.filter(user => user._id !== id)])
                //     this.$store.dispatch('remove', { path: 'users', id })
                // }
            } catch (e) {
                console.log(e)
                console.log('error deleting user')
            }
        }
    }
}
</script>